import React from "react";
import "./Stylesheets/Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <footer>
        <h4 className="fs-5">&copy; Copyright 2023 By Sahid Munjavar</h4>
      </footer>
    </div>
  );
}
